import { graphql } from 'gatsby';
import * as React from 'react';
import Header from '../components/Header';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import Footer from '../components/Footer';

const CourseListStyles = styled.div`
  max-width: 900px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 100px;
  grid-auto-rows: min-content;

  @media screen and (max-width: 600px) {
    gap: 10px;
  }
`;

const CourseStyles = styled.article`
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 30px;

  img {
    grid-column-start: 1;
  }

  .course-description {
    grid-column-start: 2;

    max-width: 65ch;

    h2 {
      font-family: var(--body-font);
      font-size: var(--h5);
      margin-top: 0;
    }
  }

  @media screen and (max-width: 769px) {
    grid-template-columns: 1fr 2fr;
  }

  @media screen and (max-width: 600px) {
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14),
      0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);

    padding: 1rem;
    margin: 0 1rem;

    grid-template-columns: 1fr;

    img {
      grid-column-start: auto;
    }
    .course-description {
      grid-column-start: auto;
    }
  }
`;

const CoursePage = ({ data }) => {
  const courses = data.allSanityCourse.nodes;

  return (
    <>
      <Header />
      <main>
        <title>Course Page</title>
        <h1>Courses</h1>
        <CourseListStyles>
          {courses
            .sort((a, b) => {
              if (a.courseName[0] === b.courseName[0]) {
                return a.courseNumber > b.courseNumber ? -1 : 1;
              } else {
                return a.courseName > b.courseName ? 1 : -1;
              }
            })
            .map((course) => {
              return (
                <CourseStyles key={course.id}>
                  <GatsbyImage
                    image={course.image.asset.gatsbyImageData}
                    alt={course.courseName}
                  />
                  {/* TODO: Figure out this text block stuff with 'portable text' correctly */}
                  <div className="course-description">
                    <h2>{course.courseName}</h2>
                    <p>{course.description[0].children[0].text}</p>
                  </div>
                </CourseStyles>
              );
            })}
        </CourseListStyles>
      </main>
      <Footer />
    </>
  );
};

export default CoursePage;

export const query = graphql`
  {
    allSanityCourse(sort: { fields: courseNumber, order: DESC }) {
      nodes {
        id
        courseNumber
        courseName
        description {
          children {
            text
          }
        }
        image {
          asset {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
